import { instanceV2 } from "../../api";

// Messaging-v2 business endpoints. Routing/disconnect/opt-outs land in
// /api/v2/branches/:branchID/whatsapp/*; chat endpoints in the same tree
// support inline conversation surfacing on the WhatsApp page when the
// branded channel is connected.
const whatsappApi = {
    getChannels: (branchID) =>
        instanceV2().get(`/branches/${branchID}/whatsapp/channels`).then((r) => r.data),
    putRouting: (branchID, routing) =>
        instanceV2().put(`/branches/${branchID}/whatsapp/routing`, routing).then((r) => r.data),
    connectChannel: (branchID, slot, body) =>
        instanceV2()
            .post(`/branches/${branchID}/whatsapp/channels/${slot}/connect`, body || {})
            .then((r) => r.data),
    disconnectChannel: (branchID, slot) =>
        instanceV2().post(`/branches/${branchID}/whatsapp/channels/${slot}/disconnect`).then((r) => r.data),

    getTemplates: (branchID) =>
        instanceV2().get(`/branches/${branchID}/whatsapp/templates`),

    addOptOut: (branchID, payload) =>
        instanceV2().post(`/branches/${branchID}/whatsapp/opt-outs`, payload).then((r) => r.data),
    removeOptOut: (branchID, phone) =>
        instanceV2()
            .delete(`/branches/${branchID}/whatsapp/opt-outs/${encodeURIComponent(phone)}`)
            .then((r) => r.data),
};

export default whatsappApi;
